import { render } from "./chatWindow.vue?vue&type=template&id=6c436f3a"
import script from "./chatWindow.vue?vue&type=script&lang=js"
export * from "./chatWindow.vue?vue&type=script&lang=js"

import "./chatWindow.vue?vue&type=style&index=0&id=6c436f3a&lang=scss"
script.render = render

export default script